import robuxModule from '../robuxModule';

function robuxContainerCnb(
  $compile,
  $filter,
  premiumService,
  premiumConstants,
  premiumConstantsService
) {
  'ngInject';

  return {
    restrict: 'A',
    scope: false,
    templateUrl: premiumConstants.templates.robuxContainerCnb,
    link(scope) {
      scope.subscribePageUrl = premiumService.getSubscriptionPageUrl();
      scope.isShowSuperValue = false; // default hide the super value session
      setPageDescriptionElement();

      scope.moreRobuxBtnClicked = function() {
        if (!scope.isShowSuperValue) scope.isShowSuperValue = true;
        premiumService.sendInteractionClickEvent(
          premiumConstants.pageContext.robux,
          premiumConstants.streamEventParams.wantMoreBtn
        );
      };

      scope.linkClicked = function(linkType) {
        premiumService.sendInteractionClickEvent(premiumConstants.pageContext.robux, linkType);
      };

      function setPageDescriptionElement() {
        const subtitleElement = angular.element('.top-subtitle');
        if (!subtitleElement.childElementCount) {
          const helpLinkStart = `<a href="${
            premiumConstantsService.links.robuxHelper
          }" class="text-link" ng-click="linkClicked('${
            premiumConstants.streamEventParams.robloxHelpLink
          }')">`;
          const learnMoreLinkStart = `<a ng-href={{subscribePageUrl}} class="text-link" ng-click="linkClicked('${
            premiumConstants.streamEventParams.learnMoreLink
          }')">`;
          const pageSubtitle = $filter('translate')('Description.BuyRobuxSubtitle', {
            helpLinkStart,
            helpLinkEnd: '</a>',
            paragraphBreaker: '<br/>',
            learnMoreLinkStart,
            learnMoreLinkEnd: '</a>'
          });
          const template = $compile(`<span>${pageSubtitle}</span>`)(scope);
          subtitleElement.append(template);
        }
      }
    }
  };
}

robuxModule.directive('robuxContainerCnb', robuxContainerCnb);

export default robuxModule;
